import { Currency, Price, Wallet, WalletBalance } from "@/interfaces";
import { WalletState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";

export const mutations = {
  setWallets(state: WalletState, payload: Wallet[]) {
    state.wallets = payload;
  },
  // setWithdraws(state: WalletState, payload: Withdraw[]) {
  //   state.withdraws = payload;
  // },
  setCurrencies(state: WalletState, payload: Currency[]) {
    state.currencies = payload;
  },
  setPrices(state: WalletState, payload: Price[]) {
    state.prices = payload;
  },
  setWallet(state: WalletState, payload: Wallet) {
    const wallets = state.wallets.filter(
      (wallet: Wallet) => wallet.id !== payload.id
    );
    wallets.push(payload);
    state.wallets = wallets;
  },
  // setWithdraw(state: WalletState, payload: Withdraw) {
  //   const withdraws = state.withdraws.filter(
  //     (withdraw: Withdraw) => withdraw.id !== payload.id
  //   );
  //   withdraws.push(payload);
  //   state.withdraws = withdraws;
  // },
  setWalletBalance(
    state: WalletState,
    payload: { id: number; balance: WalletBalance }
  ) {
    const wallet = state.wallets.find(
      (wallet: Wallet) => wallet.id !== payload.id
    );
    wallet!.wallet_balance = payload.balance;
  },
};

const { commit } = getStoreAccessors<WalletState, State>("");

export const commitSetWallet = commit(mutations.setWallet);
export const commitSetWallets = commit(mutations.setWallets);
export const commitSetCurrencies = commit(mutations.setCurrencies);
export const commitSetPrices = commit(mutations.setPrices);
export const commitSetWalletBalance = commit(mutations.setWalletBalance);
